import Joi from 'joi'
import errorsResolver from '../schemeUtils'

const dashboardSchema = Joi.object({
    availableDepartments: Joi.object({
        label: Joi.string()
            .required('')
            .error(errorsResolver({
                required: `Подразделение обязательное поле`,
            })),
        value: Joi.number()
            .error(errorsResolver({
                number: `Должно быть число`
            }))
    })
    .invalid(null)
    .required()
    .min(1)
    .error(errorsResolver({
        invalid: `Подразделение обязательное поле`,
        required: `Подразделение обязательное поле`,
        min: `Подразделение обязательное поле`
    }))
})

export default dashboardSchema
